import type { VideoSource } from 'bundles/general-video-player/components/VideoPlayer';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type OnDemandVideosV1 from 'bundles/naptimejs/resources/onDemandVideos.v1';

function extractSourcesFromOnDemandVideos(onDemandVideos: OnDemandVideosV1) {
  return Object.keys(onDemandVideos.sources.byResolution).reduce<Record<string, Array<VideoSource>>>(
    (result, resolution) => {
      const sources = onDemandVideos.sources.byResolution[resolution];

      const entries = [];
      if (sources.webMVideoUrl) {
        entries.push({ type: 'video/webm', src: sources.webMVideoUrl });
      }

      if (sources.mp4VideoUrl) {
        entries.push({ type: 'video/mp4', src: sources.mp4VideoUrl });
      }

      if (entries.length > 0) {
        return {
          ...result,
          [resolution]: entries,
        };
      } else {
        return result;
      }
    },
    {}
  );
}

export default extractSourcesFromOnDemandVideos;
